// Breed data for different species - Lista completa razze riconosciute

export const breedsBySpecies = {
  dog: [
    // Gruppo 1 - Cani da pastore e bovari
    "Pastore Tedesco",
    "Pastore Australiano",
    "Pastore Belga Malinois",
    "Pastore Belga Groenendael",
    "Pastore Belga Tervueren",
    "Pastore Belga Laekenois",
    "Pastore Olandese",
    "Pastore Svizzero Bianco",
    "Border Collie",
    "Collie (Pelo Lungo)",
    "Collie (Pelo Corto)",
    "Pastore Scozzese Shetland",
    "Bearded Collie",
    "Old English Sheepdog",
    "Pastore dei Pirenei",
    "Bovaro del Bernese",
    "Bovaro delle Fiandre",
    "Bovaro dell'Appenzell",
    "Bovaro dell'Entlebuch",
    "Australian Cattle Dog",
    "Welsh Corgi Pembroke",
    "Welsh Corgi Cardigan",
    "Cane da Pastore Bergamasco",
    "Cane da Pastore Maremmano Abruzzese",
    "Komondor",
    "Kuvasz",
    "Puli",
    "Pumi",
    "Mudi",
    "Cane da Pastore Polacco di Pianura",
    "Cane da Pastore Polacco di Podhale",
    "Pastore del Caucaso",
    "Pastore dell'Asia Centrale",
    "Pastore di Beauce",
    "Pastore di Brie",
    "Pastore dei Pirenei a Pelo Lungo",
    "Pastore Catalano",
    "Cane Lupo Cecoslovacco",
    "Cane Lupo di Saarloos",
    "Pastore Croato",
    "Pastore Islandese",
    "Pastore Finlandese della Lapponia",
    "Cane da Pastore Scozzese",
    // Gruppo 2 - Pinscher, Schnauzer, Molossoidi
    "Dobermann",
    "Pinscher Tedesco",
    "Pinscher Nano",
    "Affenpinscher",
    "Schnauzer Gigante",
    "Schnauzer Medio",
    "Schnauzer Nano",
    "Rottweiler",
    "Boxer",
    "Bullmastiff",
    "Mastiff (Mastino Inglese)",
    "Mastino Napoletano",
    "Cane Corso",
    "Dogo Argentino",
    "Dogue de Bordeaux",
    "Fila Brasileiro",
    "Tosa Inu",
    "Alano (Gran Danese)",
    "San Bernardo",
    "Terranova",
    "Landseer",
    "Leonberger",
    "Hovawart",
    "Cane da Montagna dei Pirenei",
    "Cane da Serra da Estrela",
    "Cane da Pastore di Kangal",
    "Mastino Tibetano",
    "Shar Pei",
    "Broholmer",
    "Cimarrón Uruguayo",
    "Dogo Canario",
    "Perro de Presa Mallorquin",
    "Rafeiro do Alentejo",
    // Gruppo 3 - Terrier
    "Airedale Terrier",
    "Bedlington Terrier",
    "Border Terrier",
    "Bull Terrier",
    "Bull Terrier Miniature",
    "Cairn Terrier",
    "Dandie Dinmont Terrier",
    "Fox Terrier Pelo Liscio",
    "Fox Terrier Pelo Ruvido",
    "Irish Terrier",
    "Jack Russell Terrier",
    "Kerry Blue Terrier",
    "Lakeland Terrier",
    "Manchester Terrier",
    "Norfolk Terrier",
    "Norwich Terrier",
    "Parson Russell Terrier",
    "Scottish Terrier",
    "Sealyham Terrier",
    "Skye Terrier",
    "Soft Coated Wheaten Terrier",
    "Staffordshire Bull Terrier",
    "Welsh Terrier",
    "West Highland White Terrier",
    "Yorkshire Terrier",
    "American Staffordshire Terrier",
    "Australian Terrier",
    "Cesky Terrier",
    "Glen of Imaal Terrier",
    "Irish Soft Coated Wheaten Terrier",
    "Jagdterrier",
    "Nihon Terrier",
    "Rat Terrier",
    "Silky Terrier",
    "Toy Fox Terrier",
    // Gruppo 4 - Bassotti
    "Bassotto a Pelo Corto",
    "Bassotto a Pelo Duro",
    "Bassotto a Pelo Lungo",
    "Bassotto Nano a Pelo Corto",
    "Bassotto Nano a Pelo Duro",
    "Bassotto Nano a Pelo Lungo",
    "Bassotto Kaninchen a Pelo Corto",
    "Bassotto Kaninchen a Pelo Duro",
    "Bassotto Kaninchen a Pelo Lungo",
    // Gruppo 5 - Spitz e Primitivi
    "Akita Inu",
    "Akita Americano",
    "Shiba Inu",
    "Hokkaido",
    "Kai",
    "Kishu",
    "Shikoku",
    "Spitz Tedesco Grande",
    "Spitz Tedesco Medio",
    "Spitz Tedesco Piccolo",
    "Spitz Tedesco Nano (Pomerania)",
    "Spitz di Norrbotten",
    "Spitz Finlandese",
    "Volpino Italiano",
    "Samoiedo",
    "Siberian Husky",
    "Alaskan Malamute",
    "Groenlandese",
    "Cane Eschimese Canadese",
    "Laika della Siberia Occidentale",
    "Laika della Siberia Orientale",
    "Laika Russo-Europeo",
    "Norsk Buhund",
    "Norsk Lundehund",
    "Västgötaspets",
    "Chow Chow",
    "Eurasier",
    "Basenji",
    "Thai Ridgeback",
    "Cirneco dell'Etna",
    "Podenco Ibicenco",
    "Podenco Canario",
    "Podengo Portoghese Grande",
    "Podengo Portoghese Medio",
    "Podengo Portoghese Piccolo",
    "Pharaoh Hound",
    "Perro sin Pelo del Perù",
    "Xoloitzcuintle",
    // Gruppo 6 - Segugi e Cani per Pista di Sangue
    "Segugio Italiano a Pelo Raso",
    "Segugio Italiano a Pelo Forte",
    "Segugio Maremmano",
    "Beagle",
    "Beagle Harrier",
    "Bassethound",
    "Basset Artésien Normand",
    "Basset Bleu de Gascogne",
    "Basset Fauve de Bretagne",
    "Grand Basset Griffon Vendéen",
    "Petit Basset Griffon Vendéen",
    "Bloodhound",
    "Foxhound Inglese",
    "Foxhound Americano",
    "Harrier",
    "Otterhound",
    "Coonhound",
    "Dalmata",
    "Rhodesian Ridgeback",
    "Grand Bleu de Gascogne",
    "Porcelaine",
    "Billy",
    "Ariégeois",
    "Chien d'Artois",
    "Briquet Griffon Vendéen",
    "Anglo-Français de Petite Vénerie",
    "Dunker",
    "Haldenstøver",
    "Hygenhund",
    "Drever",
    "Finnish Hound",
    "Hamilton Stövare",
    "Schillerstövare",
    "Smålandsstövare",
    "Segugio Bavarese",
    "Segugio di Hannover",
    "Segugio del Tirolo",
    "Segugio Stiriano a Pelo Ruvido",
    "Brandlbracke",
    "Posavski Gonic",
    "Istarski Kratkodlaki Gonic",
    "Sabueso Español",
    "Schweizer Laufhund",
    "Petit Bleu de Gascogne",
    "Griffon Bleu de Gascogne",
    "Griffon Fauve de Bretagne",
    "Griffon Nivernais",
    "Grand Griffon Vendéen",
    // Gruppo 7 - Cani da Ferma
    "Pointer Inglese",
    "Setter Inglese",
    "Setter Irlandese Rosso",
    "Setter Irlandese Rosso e Bianco",
    "Setter Gordon",
    "Bracco Italiano",
    "Spinone Italiano",
    "Bracco Tedesco a Pelo Corto",
    "Bracco Tedesco a Pelo Duro",
    "Weimaraner",
    "Weimaraner a Pelo Lungo",
    "Vizsla (Bracco Ungherese a Pelo Corto)",
    "Vizsla a Pelo Duro",
    "Bracco di Weimar",
    "Epagneul Breton",
    "Epagneul Français",
    "Epagneul Picard",
    "Epagneul Pont-Audemer",
    "Epagneul Bleu de Picardie",
    "Braque d'Auvergne",
    "Braque du Bourbonnais",
    "Braque Français Type Gascogne",
    "Braque Français Type Pyrénées",
    "Braque Saint-Germain",
    "Griffon a Pelo Duro (Korthals)",
    "Barbone (Poodle Pointer)",
    "Cesky Fousek",
    "Drentse Patrijshond",
    "Stabyhoun",
    "Wetterhoun",
    "Kleiner Münsterländer",
    "Großer Münsterländer",
    "Langhaar",
    "Stichelhaar",
    "Perdigueiro Português",
    "Perdiguero de Burgos",
    "Bracco Slovacco a Pelo Duro",
    // Gruppo 8 - Cani da Riporto, da Cerca e da Acqua
    "Labrador Retriever",
    "Golden Retriever",
    "Flat Coated Retriever",
    "Curly Coated Retriever",
    "Chesapeake Bay Retriever",
    "Nova Scotia Duck Tolling Retriever",
    "Cocker Spaniel Inglese",
    "Cocker Spaniel Americano",
    "English Springer Spaniel",
    "Welsh Springer Spaniel",
    "Field Spaniel",
    "Sussex Spaniel",
    "Clumber Spaniel",
    "Irish Water Spaniel",
    "American Water Spaniel",
    "Boykin Spaniel",
    "Lagotto Romagnolo",
    "Barbet",
    "Cão de Água Português",
    "Wetterhoun",
    "Perro de Agua Español",
    "Frisone (Stabyhoun)",
    "Nederlandse Kooikerhondje",
    // Gruppo 9 - Cani da Compagnia
    "Barboncino Toy",
    "Barboncino Nano",
    "Barboncino Medio",
    "Barboncino Grande",
    "Bichon Frisé",
    "Bichon Maltese (Maltese)",
    "Bichon Havanais",
    "Bichon Bolognese",
    "Coton de Tuléar",
    "Löwchen (Piccolo Cane Leone)",
    "Cavalier King Charles Spaniel",
    "King Charles Spaniel",
    "Papillon",
    "Phalène",
    "Chihuahua a Pelo Corto",
    "Chihuahua a Pelo Lungo",
    "Carlino (Pug)",
    "Griffone di Bruxelles",
    "Griffone Belga",
    "Petit Brabançon",
    "Bulldog Francese",
    "Bulldog Inglese",
    "Boston Terrier",
    "Pechinese",
    "Japanese Chin",
    "Shih Tzu",
    "Lhasa Apso",
    "Tibetan Spaniel",
    "Tibetan Terrier",
    "Chinese Crested Dog",
    "Kromfohrländer",
    "Russkiy Toy",
    "Prague Ratter",
    // Gruppo 10 - Levrieri
    "Levriero Afgano",
    "Levriero Russo (Borzoi)",
    "Saluki",
    "Levriero Irlandese (Irish Wolfhound)",
    "Deerhound (Scottish Deerhound)",
    "Greyhound",
    "Whippet",
    "Piccolo Levriero Italiano",
    "Sloughi",
    "Azawakh",
    "Galgo Español",
    "Magyar Agar",
    "Chart Polski",
    "Levriero Arabo",
    // Altre razze riconosciute
    "American Bully",
    "Catahoula Leopard Dog",
    "Australian Kelpie",
    "Australian Stumpy Tail Cattle Dog",
    "Carolina Dog",
    "Chinook",
    "Formosan Mountain Dog",
    "Kai Ken",
    "Kintamani",
    "Korean Jindo",
    "Kunming Wolfdog",
    "New Guinea Singing Dog",
    "Taiwan Dog",
    "Thai Bangkaew Dog",
    "Meticcio",
    "Altro"
  ],
  
  cat: [
    // Razze a pelo lungo
    "Persiano",
    "Persiano Chinchilla",
    "Persiano Exotic",
    "Himalayano",
    "Maine Coon",
    "Norvegese delle Foreste",
    "Siberiano",
    "Neva Masquerade",
    "Ragdoll",
    "Ragamuffin",
    "Sacro di Birmania",
    "Turco Van",
    "Angora Turco",
    "Somalo",
    "Balinese",
    "Javanese",
    "Tiffanie",
    "Chantilly-Tiffany",
    "Cymric",
    "LaPerm a Pelo Lungo",
    "Selkirk Rex a Pelo Lungo",
    "American Curl a Pelo Lungo",
    "Scottish Fold a Pelo Lungo (Highland Fold)",
    "British Longhair",
    "Oriental Longhair",
    "Nebelung",
    // Razze a pelo semi-lungo
    "Turco Van",
    "Turkish Angora",
    "Somali",
    // Razze a pelo corto
    "Europeo (European Shorthair)",
    "British Shorthair",
    "British Blue",
    "American Shorthair",
    "Exotic Shorthair",
    "Siamese Tradizionale",
    "Siamese Moderno",
    "Thai (Old-Style Siamese)",
    "Orientale a Pelo Corto",
    "Havana Brown",
    "Tonkinese",
    "Burmese Americano",
    "Burmese Europeo",
    "Bombay",
    "Burmilla",
    "Asian",
    "Tiffanie",
    "Abissino",
    "Singapura",
    "Russian Blue",
    "Korat",
    "Chartreux (Certosino)",
    "Egyptian Mau",
    "Ocicat",
    "Bengala",
    "Savannah",
    "Toyger",
    "Chausie",
    "Pixie-Bob",
    "Safari",
    "Serengeti",
    "American Wirehair",
    "American Curl a Pelo Corto",
    "Scottish Fold a Pelo Corto",
    "Scottish Straight",
    "Manx",
    "Japanese Bobtail",
    "Kurilian Bobtail",
    "American Bobtail",
    "Mekong Bobtail",
    "Devon Rex",
    "Cornish Rex",
    "German Rex",
    "Selkirk Rex a Pelo Corto",
    "LaPerm a Pelo Corto",
    "Munchkin",
    "Snowshoe",
    "Sokoke",
    "Australian Mist",
    "Brazilian Shorthair",
    "California Spangled",
    "Ceylon",
    "Colorpoint Shorthair",
    "Dragon Li",
    "European Burmese",
    "German Longhair",
    "Kanaani",
    "Khao Manee",
    "Lykoi",
    "Ojos Azules",
    "Peterbald",
    "RagaMuffin",
    "Suphalak",
    "Ukrainian Levkoy",
    "York Chocolate",
    // Razze senza pelo
    "Sphynx",
    "Don Sphynx (Donskoy)",
    "Peterbald",
    "Elf Cat",
    "Bambino",
    "Dwelf",
    "Kohana",
    "Levkoy Ucraino",
    // Razze rare e nuove
    "Cheetoh",
    "Highlander",
    "Napoleon (Minuet)",
    "Serengeti",
    "Ashera",
    "Genetta",
    "Caracat",
    "Meticcio",
    "Altro"
  ],
  
  horse: [
    // Razze italiane
    "Cavallo Agricolo Italiano da Tiro Pesante Rapido",
    "Haflinger",
    "Lipizzano",
    "Maremmano",
    "Murgese",
    "Persano",
    "Pony di Esperia",
    "Sanfratellano",
    "Sarcidano",
    "Tolfetano",
    "Salernitano",
    "Cavallino della Giara",
    "Bardigiano",
    "Monterufolino",
    "Napoletano",
    "Avelignese",
    // Razze europee
    "Andaluso (Pura Raza Española)",
    "Lusitano",
    "Frisone",
    "Hannoveriano",
    "Holsteiner",
    "Oldenburger",
    "Westfaliano",
    "Trakehner",
    "KWPN (Olandese)",
    "Belga da Sella",
    "Sella Francese",
    "Anglo-Arabo",
    "Selle Français",
    "Irish Sport Horse",
    "Clydesdale",
    "Shire",
    "Percheron",
    "Brabantino (Belga da Tiro)",
    "Bretone",
    "Ardennese",
    "Boulonnais",
    "Suffolk Punch",
    "Noriker",
    "Fjord Norvegese",
    "Dole",
    "Frederiksborg",
    "Knabstrupper",
    "Shagya Arabo",
    "Purosangue Inglese",
    "Anglo-Arabo Francese",
    "Sella Italiano",
    // Razze americane
    "Quarter Horse",
    "Paint Horse",
    "Appaloosa",
    "Morgan",
    "Tennessee Walking Horse",
    "Standardbred",
    "Saddlebred (American Saddlebred)",
    "Missouri Fox Trotter",
    "Rocky Mountain Horse",
    "Mustang",
    "Paso Fino",
    "Peruvian Paso",
    "Criollo",
    // Razze arabe e orientali
    "Arabo",
    "Arabo Egiziano",
    "Arabo Polacco",
    "Akhal-Teke",
    "Karabakh",
    "Turkmeno",
    // Razze da corsa e sport
    "Purosangue Inglese",
    "Trottatore Francese",
    "Trottatore Americano",
    "Trottatore Italiano",
    // Pony
    "Welsh Pony",
    "Welsh Cob",
    "Shetland",
    "Connemara",
    "New Forest",
    "Dartmoor",
    "Exmoor",
    "Fell",
    "Dales",
    "Highland",
    "Hackney Pony",
    "Pony of the Americas",
    "Falabella",
    "Miniature Horse",
    "Icelandic Horse",
    // Razze rare
    "Camargue",
    "Konik",
    "Przewalski",
    "Asino (varie razze)",
    "Mulo",
    "Bardotto",
    "Altro"
  ],
  
  bird: [
    // Pappagalli grandi
    "Ara Ararauna (Ara Blu e Giallo)",
    "Ara Macao (Ara Rossa)",
    "Ara Chloroptera (Ara Ali Verdi)",
    "Ara Militare",
    "Ara Giacinto",
    "Cacatua Alba",
    "Cacatua delle Molucche",
    "Cacatua Ciuffo Giallo",
    "Cacatua Rosa (Galah)",
    "Cacatua Nero",
    "Amazzone Fronte Blu",
    "Amazzone Fronte Gialla",
    "Amazzone Nuca Gialla",
    "Amazzone Guance Verdi",
    "Amazzone Auropalliata",
    "Cenerino (Pappagallo Grigio Africano)",
    "Cenerino del Timneh",
    "Ecletto",
    // Pappagalli medi
    "Calopsitta (Cockatiel)",
    "Conuro del Sole",
    "Conuro Guance Verdi",
    "Conuro Jenday",
    "Conuro Nanday",
    "Conuro Patagonico",
    "Parrocchetto Monaco",
    "Parrocchetto dal Collare (Ringneck)",
    "Parrocchetto Alessandrino",
    "Pappagallo del Senegal",
    "Pappagallo Meyer",
    "Pappagallo del Capo",
    "Pappagallo Jardine",
    "Pionus Testa Blu",
    "Pionus Maximilian",
    "Caicco Testa Nera",
    "Caicco Testa Bianca",
    // Pappagalli piccoli
    "Pappagallino Ondulato (Cocorita)",
    "Agapornis Roseicollis",
    "Agapornis Fischeri",
    "Agapornis Personatus",
    "Agapornis Nigrigenis",
    "Forpus",
    "Parrotlet",
    "Lori Arcobaleno",
    "Lorichetto",
    // Canarini
    "Canarino Comune",
    "Canarino Harz",
    "Canarino Malinois",
    "Canarino Timbrado",
    "Canarino Gloster",
    "Canarino Norwich",
    "Canarino Yorkshire",
    "Canarino Border",
    "Canarino Lizard",
    "Canarino Rosso",
    "Canarino Frisé",
    "Canarino AGI",
    "Canarino Gibber Italicus",
    // Fringillidi e esotici
    "Cardellino",
    "Fringuello",
    "Verdone",
    "Verzellino",
    "Lucherino",
    "Fanello",
    "Diamante Mandarino",
    "Diamante di Gould",
    "Passero del Giappone",
    "Bengalino",
    "Diamante Codalunga",
    "Diamante di Bicheno",
    "Cordon Bleu",
    "Amaranto",
    "Granatino",
    // Uccelli da cortile
    "Gallina Livornese",
    "Gallina Padovana",
    "Gallina Polverara",
    "Gallina Siciliana",
    "Gallina Ancona",
    "Gallina Valdarno",
    "Gallina Robusta Lionata",
    "Gallina Modenese",
    "Gallina Romagnola",
    "Gallina Ermellinata di Rovigo",
    "Gallina Pepoi",
    "Tacchino",
    "Faraona",
    "Anatra",
    "Oca",
    "Quaglia",
    "Fagiano",
    "Pavone",
    // Altri
    "Merlo Indiano",
    "Mynah",
    "Tucano",
    "Altro"
  ],
  
  rabbit: [
    // Razze giganti
    "Gigante Fiammingo",
    "Gigante Bianco di Bouscat",
    "Gigante Papillon Francese",
    "Gigante Checkered",
    "British Giant",
    "Continental Giant",
    // Razze medie
    "Ariete Francese",
    "Ariete Inglese",
    "Ariete Tedesco",
    "Californiano",
    "Neo Zelandese Bianco",
    "Neo Zelandese Rosso",
    "Neo Zelandese Nero",
    "Fulvo di Borgogna",
    "Champagne d'Argent",
    "Crème d'Argent",
    "Argenté de Champagne",
    "Blu di Vienna",
    "Bianco di Vienna",
    "Grigio di Vienna",
    "Cincillà",
    "Rex (Standard)",
    "Rex Castorex",
    "Hotot",
    "Papillon",
    "Alaska",
    "Havana",
    "Lilla",
    "Palomino",
    "Satin",
    "Silver Fox",
    "Silver Marten",
    "Tan",
    "Thuringer",
    "American",
    "American Chinchilla",
    "Belgian Hare",
    "Beveren",
    "Blanc de Termonde",
    "Rhinelander",
    "Harlequin",
    // Razze nane
    "Nano Colorato (Ermellino)",
    "Nano Olandese",
    "Mini Rex",
    "Mini Satin",
    "Mini Lop",
    "Holland Lop",
    "Ariete Nano",
    "Fuzzy Lop (Americano)",
    "Jersey Wooly",
    "Nano Testa di Leone",
    "Lionhead",
    "Britannia Petite",
    "Dwarf Hotot",
    "Polish",
    "Himalayano",
    "Hermelin",
    "Nano Angora",
    // Razze a pelo lungo
    "Angora Inglese",
    "Angora Francese",
    "Angora Tedesco",
    "Angora Gigante",
    "Angora Satin",
    "Cashmere Lop",
    "American Fuzzy Lop",
    // Razze rare
    "Blanc de Hotot",
    "Cinnamon",
    "Lilac",
    "Meticcio",
    "Altro"
  ],
  
  other: [
    // Rettili
    "Tartaruga di Terra",
    "Tartaruga d'Acqua",
    "Pogona (Drago Barbuto)",
    "Geco Leopardino",
    "Iguana Verde",
    "Camaleonte",
    "Serpente del Grano",
    "Pitone Reale",
    "Boa Constrictor",
    // Roditori
    "Criceto Dorato",
    "Criceto Russo",
    "Criceto Roborovski",
    "Criceto Cinese",
    "Gerbillo",
    "Cavia Peruviana",
    "Cincillà",
    "Degu",
    "Scoiattolo",
    "Topo Domestico",
    "Ratto Domestico",
    // Furetti
    "Furetto",
    "Furetto Albino",
    "Furetto Sable",
    // Pesci
    "Pesce Rosso",
    "Betta",
    "Guppy",
    "Neon",
    "Discus",
    "Scalare",
    "Koi",
    // Altri
    "Riccio Africano",
    "Petauro dello Zucchero",
    "Altro"
  ]
};

export const getBreedsBySpecies = (species) => {
  return breedsBySpecies[species] || breedsBySpecies.other;
};
